import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MenuRecipe from "./MenuRecipe";
import {GridList, GridListTile, GridListTileBar, IconButton} from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper,
    },
    gridList: {
        height: 300,
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
        // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
        transform: 'translateZ(0)',
    },

    titleBar: {
        background:
            'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, ' +
            'rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
    },
    icon: {
        color: 'white',
    },
}));


/**
 * This function will display the image you could see on RecipePage component
 * @param recipe            {object}  : recipe's data
 * @param recipeIngredients {object}  : recipe ingredients' name and quantity
 * @param displayAction     {boolean} : true if we have to display the menu (if auth exist)
 * @return {*}
 * @constructor
 */
export default function RecipeImage({ recipe, recipeIngredients , displayAction}) {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <GridList className={classes.gridList}>
                <GridListTile style={{height: 300, width:"auto"}}>
                    <img src={recipe.image} alt={recipe.name} />
                    <GridListTileBar
                        title={recipe.name}
                        titlePosition="top"
                        actionIcon={displayAction ?
                            <IconButton aria-label={`star ${recipe.name}`} className={classes.icon}>
                                <MenuRecipe recipe={recipe} recipeIngredients={recipeIngredients}/>
                            </IconButton>
                            : null
                        }
                        actionPosition="right"
                        className={classes.titleBar}
                    />
                </GridListTile>
            </GridList>
        </div>
    );
}
